<template>
  <Toast
    id="tw-wrapper"
    position="top-center"
    group="tw"
    successIcon="fa-solid fa-circle-check"
    infoIcon="fa-solid fa-circle-info"
    errorIcon="fa-solid fa-circle-xmark"
    warnIcon="fa-solid fa-triangle-exclamation">
    <template #closeicon>
      <i class="fa-solid fa-times"></i>
    </template>
  </Toast>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Toast, { type ToastMessageOptions } from 'primevue/toast'
import type { ToastTypes } from '@/enums/components.enum'

export default defineComponent({
  components: { Toast }
})

export type ToastResponse = { success: boolean; toast?: ToastMessageOptions }
</script>
